import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { css } from "@emotion/react";
import BaseAttachment from "../BaseAttachment";
const BaseFileAttachment = ({ iconSize = "medium", title, id, children, ...rest }) => (_jsx(BaseAttachment, { iconSize: iconSize, title: title, children: _jsxs("label", { css: css `
        cursor: inherit;
      `, htmlFor: id, children: [_jsx("input", { id: id, ...rest }), children] }) }));
export default memo(BaseFileAttachment);
